module.exports = __webpack_public_path__ + "img/d0a36c9.jpg";